module.exports = __webpack_public_path__ + "static/img/son8.22cab2d6.png";